import { render, staticRenderFns } from "./VideoTools.vue?vue&type=template&id=288b9896&scoped=true"
import script from "./VideoTools.vue?vue&type=script&lang=js"
export * from "./VideoTools.vue?vue&type=script&lang=js"
import style0 from "./VideoTools.vue?vue&type=style&index=0&id=288b9896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b9896",
  null
  
)

export default component.exports